import styles from './AvatarWithMarketplace.module.scss';
import Avatar from '@components/Avatar';
import cn from 'classnames';
import MarketplaceIcon from '@components/MarketplaceIcon';
import { Row } from '@components/Grid';
import { Seller } from '@api/apiClient';
import { Tooltip } from '@components/new/Tooltip';


interface AvatarWithMarketplaceProps {
  id?: string;
  name: string | Seller[];
  marketplace?: string;
  className?: string;
  type?: 'big' | 'medium' | 'small' | 'smaller';
  noHover?: boolean;
  wide?: boolean;
  showAll?: boolean;
}

const AvatarWithMarketplace: React.FC<AvatarWithMarketplaceProps> = ({
  id,
  name,
  marketplace,
  className,
  type,
  noHover,
  wide,
  showAll
}) => {
  return (
      <div
          className={cn(
              styles.root,
              className,
              styles[type || 'small'],
              wide && styles[`wide-${type || 'small'}`]
          )}
      >
        {typeof name === 'string' ? (
            <Tooltip
                action={
                  <Row noWrap align="center">
                    <Avatar
                        className={styles.avatar}
                        type={type || 'small'}
                        name={name}
                        id={id}
                    />
                    {marketplace && (
                        <MarketplaceIcon
                            className={styles.marketplace}
                            marketplace={marketplace}
                        />
                    )}
                  </Row>
                }
                position="top"
                text={name}
                disabled={noHover}
            />
        ) : (
            <Row align="center">
              <>
                {name.map((item: Seller, index: number) => {
                  if (showAll || index < 3) {
                    return (
                        <div
                            className={styles.avatarWrapper}
                            key={item.id}
                            style={{ zIndex: index ? name.length - index : name.length }}
                        >
                          <Avatar
                              className={styles.avatar}
                              id={item.id}
                              name={item.name}
                              type={type || 'small'}
                          />
                        </div>
                    );
                  }
                })}
                {showAll || name.length > 3 && (
                    <div className={styles.avatarCounter}>+{name.length - 3}</div>
                )}
              </>
            </Row>
        )}
      </div>
  );
};

export default AvatarWithMarketplace;
